import _ from 'lodash';
import { createClient } from '@/shared/api';
import type { EventQuery, EventQueryVariables } from '@/shared/api';
import ELECTROPHYSIOLOGIST_EVENT_QUERY from '../queries/electrophysiologistEvent';

/**
 * Loads the ECG event reviewed by an electrophysiologist. Runs ELECTROPHYSIOLOGIST_EVENT_QUERY and throws the first GraphQL error message when the event field is nil.
 *
 * @param id - Identifier of the event to load.
 * @returns The event record.
 */
const fetchElectrophysiologistEvent = async (id: any) => {
  const client = createClient();
  const eventResult = await client.query<EventQuery, EventQueryVariables>({
    query: ELECTROPHYSIOLOGIST_EVENT_QUERY,
    variables: { id },
  });
  const { data, errors } = eventResult;
  const { event } = data;
  if (_.isNil(event) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return event;
};

export default fetchElectrophysiologistEvent;
